import { UserEssential } from "../sso/User.dto";

export interface FolderSharingRoleBy {
  folderId: bigint;
  fileId?: bigint;
}

export enum FolderSharingRole {
  None = "NONE",
  OnlineViewer = "ONLINE-VIEWER",
  Viewer = "VIEWER",
  OnlineContributor = "ONLINE-CONTRIBUTOR",
  Contributor = "CONTRIBUTOR",
  Manager = "MANAGER",
  Owner = "OWNER",
  Admin = "ADMIN", // ENUM ONLY - Inherited (ORG ADMIN)
}

export enum FolderSharingType {
  Member = "MEMBER",
  External = "EXTERNAL",
}

export type FolderSharing = FolderSharingToMember | FolderSharingToExternal;

interface FolderSharingBase {
  id: bigint;
  organizationId: bigint;
  folderId: bigint;
  fileId: bigint;
  sharingRole: FolderSharingRole;
  overriddenRole?: FolderSharingRole;
  isInherited: boolean;
}

export interface FolderSharingToMember extends FolderSharingBase {
  sharingType: FolderSharingType.Member;
  user: UserEssential;
}

export interface FolderSharingToExternal extends FolderSharingBase {
  sharingType: FolderSharingType.External;
  email: string;
}

export type FolderSharingSummary = FolderSharingToMemberSummary | FolderSharingToExternalSummary;

export interface FolderSharingToMemberSummary {
  id: bigint;
  folderId: bigint;
  fileId?: bigint;
  sharingType: FolderSharingType.Member;
  sharingRole: FolderSharingRole;
  userId: bigint;
}

export interface FolderSharingToExternalSummary {
  id: bigint;
  folderId: bigint;
  fileId?: bigint;
  sharingType: FolderSharingType.External;
  sharingRole: FolderSharingRole;
  email: string;
}

export interface GetFolderSharingsRequest {
  organizationId: bigint;
  folderId?: bigint;
  fileId?: bigint;
}

export interface GetFolderSharingsResponse {
  sharings: FolderSharing[];
}

export interface CreateFolderSharingsExternalRequest {
  organizationId: bigint;
  folderId?: bigint;
  fileId?: bigint;
  email: string;
}

export interface CreateFolderSharingsExternalResponse {
  sharings: FolderSharing[];
}

export interface RemoveFolderSharingsRequest {
  sharingId: bigint;
}

export interface RemoveFolderSharingsResponse {
  sharings: FolderSharing[];
}

export type FolderSharingPayload = FolderSharingForMemberPayload | FolderSharingByIdPayload;

export interface FolderSharingForMemberPayload {
  userId: bigint;
  sharingRole: FolderSharingRole;
}

export interface FolderSharingByIdPayload {
  sharingId: bigint;
  sharingRole: FolderSharingRole;
}

export interface UpsertFolderSharingsRequest {
  organizationId: bigint;
  folderId?: bigint;
  fileId?: bigint;
  sharings: FolderSharingPayload[];
}

export interface UpsertFolderSharingsResponse {
  sharings: FolderSharing[];
}

export interface FolderSharingLink {
  id: bigint;
  organizationId: bigint;
  folderId: bigint;
  fileId: bigint;
  token: string;
}
